export default __webpack_public_path__ + "static/media/Logo.ff4d7862.png";